import type { Image as TImage } from '@frontend/libs/types/media'

import placeholder from '@images/placeholder-wide.jpg'
import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  useDisclosure,
} from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

export interface SizeGuidePopupProps {
  image: TImage
  text?: string
}

function SizeGuidePopup({ image, text = '' }: Readonly<SizeGuidePopupProps>) {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <>
      <Button
        className="h-auto p-0 underline"
        onPress={onOpen}
        type="button"
        variant="light"
      >
        {__('Size Guide', 'asavagroup')}
      </Button>
      <Modal
        classNames={{
          closeButton: 'rounded-none top-4 right-4 text-2xl z-20',
        }}
        isOpen={isOpen}
        onClose={onClose}
        placement="center"
        size="5xl"
      >
        <ModalContent>
          <ModalBody>
            {image ? (
              <Image
                alt={image.alt}
                fallbackSrc={placeholder}
                src={image.sizes.full}
                srcSet={image.srcset}
              />
            ) : (
              <div
                className="mx-auto p-8 text-lg leading-9"
                dangerouslySetInnerHTML={{ __html: text }}
              ></div>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default SizeGuidePopup
